import React from 'react';
import {
  translate as t,
} from 'admin-on-rest';
import { List, ListItem } from 'material-ui';

const FAQ = t(({ block }) => (
  <List>
    <ListItem disabled primary primaryText="Block WIP" />
    <ListItem rightToggle={<div />} rightIcon={<div />} rightIconButton={<div />} primaryTogglesNestedList primaryText="Content" nestedItems={[<ListItem primaryText={JSON.stringify(block)} />]} />
  </List>
));

export default FAQ;
